import { useState } from "react";
import Dropdown from "../DesignerPage/Dropdown";
import MultiSelectDropdown from "../DesignerPage/ReportDropdown/multiselectDropdown";
import StaticDropdown from "../DesignerPage/ReportDropdown/staticDropdown";

// components/SeveritySelector.tsx
type TrendReportProps = {
  selectedProductType: string;
  setSelectedProductType: React.Dispatch<React.SetStateAction<string>>;
  setSelectedStylingDetail: React.Dispatch<React.SetStateAction<string>>;
  setSelectedErrorType: React.Dispatch<React.SetStateAction<string>>;
  productTypes: string[];
  stylingDetailList: string[];
};

const TrendReport: React.FC<TrendReportProps> = ({
  selectedProductType,
  setSelectedProductType,
  setSelectedStylingDetail,
  setSelectedErrorType,
  productTypes,
  stylingDetailList = ["Color", "Pattern", "Emboidery", "Fabric"],
}) => {
  // Do api call karne padenge
  const handleProductTypeSelect = (option: string) => {
    setSelectedProductType(option);
  };
  const handleTrendTypeSelect = (option: string) => {
    setSelectedStylingDetail(option);
  };
  const handleErrorTypeSelect = (option: string) => {
    setSelectedErrorType(option);
  };
  return (
    <div className="w-full mb-4 space-y-2">
      <p className="text-sm font-poppins">Product Type</p>
      <StaticDropdown label={selectedProductType} />
      <p className="text-sm font-poppins">Trend Type</p>
      {selectedProductType === "All" ? (
        <MultiSelectDropdown
          label="Select Trend Type"
          options={stylingDetailList}
          onSelect={handleTrendTypeSelect}
          productType={selectedProductType}
        />
      ) : (
        <StaticDropdown label={stylingDetailList[0]} />
      )}

      <p className="text-sm font-poppins">Error Type</p>
      <Dropdown
        label="Select a Error Type"
        options={["Incorrect Tag", "Incorrect Analysis"]}
        onSelect={handleErrorTypeSelect}
      />
    </div>
  );
};

export default TrendReport;
